import React from 'react';
import { Badge } from '@/components/ui/badge';
import type { Difficulty } from '@/lib/learn';

const DIFFICULTY_STYLES: Record<Difficulty, string> = {
  beginner: 'bg-emerald-100 text-emerald-700 border-emerald-300',
  intermediate: 'bg-amber-100 text-amber-800 border-amber-300',
  advanced: 'bg-purple-100 text-purple-700 border-purple-300',
};

interface DifficultyBadgeProps {
  difficulty: Difficulty;
  className?: string;
}

export const DifficultyBadge: React.FC<DifficultyBadgeProps> = ({ difficulty, className = '' }) => {
  return (
    <Badge
      variant="outline"
      className={`text-xs capitalize ${DIFFICULTY_STYLES[difficulty]} ${className}`}
    >
      {difficulty}
    </Badge>
  );
};
